import Promise from "bluebird";

export default function loadImage(source) {
    const image = new Image();
    return new Promise((resolve, reject) => {
        image.onload = resolve;
        image.onerror = reject;
        image.src = source;
    }).return(image);
}
